<template>
  <v-autocomplete
    :disabled="disabled"
    :hide-details="hideDetails"
    :items="definedDurations"
    :label="label"
    :loading="loading"
    :placeholder="placeholder"
    :search-input.sync="search"
    :value="value"
    auto-select-first
    class="select"
    item-text="name"
    item-value="value"
    no-data-text="Ungültiger Wert"
    no-filter
    overflow
    @input="updateValue"
  />
</template>

<script>
import { formatStringDuration } from '../../filters/Duration'

// simple integer
const regexInteger = /^\d+$/i

// simple float
const regexFloat = /^(\d+)(?:\.|,)(\d*)$/i

// 1:30 format
const regexHours1 = /^(\d+):(\d+)?$/i

// 1h30m format
const regexHours2 = /^(?:(\d+)h)?(?: *)(?:(\d+)(?:m|mi|min))?$/i

export default {
  props: {
    disabled: Boolean,
    hideDetails: Boolean,
    label: {
      default: 'Arbeitszeit',
      type: String,
    },
    loading: Boolean,
    placeholder: {
      default: '',
      type: String,
    },
    value: {
      default: 15,
      type: Number,
    },
  },
  data () {
    return {
      search: '',
      blurCounter: 0
    }
  },
  computed: {
    definedDurations () {
      if (!this.search) {
        return [{
          name: formatStringDuration(this.value),
          value: this.value
        }]
      } else {
        const result = []
        const integerMatch = this.search.match(regexInteger)
        if (integerMatch) {
          const num = parseInt(integerMatch[0])
          const minuteSuggestions = [{
            name: formatStringDuration(num),
            value: num
          }]
          const hourSuggestions = [0, 15, 30, 45].map(
            min => {
              const totalMinutes = num * 60 + min
              return {
                name: formatStringDuration(totalMinutes),
                value: totalMinutes
              }
            }
          )
          if (num >= 15) {
            result.push.apply(result, Array.prototype.concat(minuteSuggestions, hourSuggestions))
          } else {
            result.push.apply(result, Array.prototype.concat(hourSuggestions, minuteSuggestions))
          }
        }
        const floatMatch = this.search.match(regexFloat)
        if (floatMatch) {
          let num = parseFloat(floatMatch[1] + '.' + floatMatch[2])
          const totalMinutes = num * 60.0
          result.push({
            name: formatStringDuration(totalMinutes),
            value: totalMinutes
          })
        }
        const hours1Match = this.search.match(regexHours1)
        if (hours1Match) {
          const hours = parseInt(hours1Match[1])
          const minutes = hours1Match[2] ? parseInt(hours1Match[2]) : false
          const variants = minutes !== false ? [minutes] : [0, 15, 30, 45]
          for (let i = 0; i < variants.length; i++) {
            const totalMinutes = hours * 60 + variants[i]
            result.push({
              name: formatStringDuration(totalMinutes),
              value: totalMinutes
            })
          }
        }
        const hours2Match = this.search.match(regexHours2)
        if (hours2Match && this.search) {
          const hours = hours2Match[1] ? parseInt(hours2Match[1]) : 0
          const minutes = hours2Match[2] ? parseInt(hours2Match[2]) : false
          const variants = minutes !== false ? [minutes] : [0, 15, 30, 45]
          for (let i = 0; i < variants.length; i++) {
            const totalMinutes = hours * 60 + variants[i]
            result.push({
              name: formatStringDuration(totalMinutes),
              value: totalMinutes
            })
          }
        }
        return result
      }
    }
  },
  methods: {
    updateValue ({value}) {
      let newValue = value
      let doUpdate = !!newValue
      if (!value) {
        const definedDurations = this.definedDurations
        if (definedDurations.length > 0) {
          newValue = definedDurations[0].value
          doUpdate = true
        }
      }
      if (doUpdate) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
